import React, { useState, useMemo, useCallback, useEffect } from "react";
import toast from "react-hot-toast";
import { callDeleteApi, callGetApi, callPutApi } from "api/ApiCaller";
import {
  Activate_UserAdmin_List_Item_PUT,
  Delete_UserAdmin_Deleted_List_Item_DELETE,
  GET_UserAdmin_Deleted_List_POST,
  Get_UserAdmin_List_Item_GET,
  GET_UserAdmin_List_POST,
  Inactivate_UserAdmin_List_Item_PUT,
  Revive_UserAdmin_List_Item_PUT,
} from "api/ApiConst";
import { API_SUCCESS } from "api/ResponseCodes";
import dateUtilities from "utils/DateUtilities.jsx";
import PaginationDataTable from "components/common/PaginationDataTable";
import { getImageSrcViaRefId } from "utils/UserUtils";
import UserAdminAddEdit from "./UserAdminAddEdit";

const UserAdminMaster = () => {
  const [record, setRecord] = useState(null);
  const [viewDeletedList, setViewDeletedList] = useState(false);
  const [refreshFlag, setRefreshFlag] = useState(0);
  const [showModal, setShowModal] = useState(null);
  const [recordID, setRecordID] = useState(null);

  useEffect(() => {
    if (!showModal) {
      setRecordID(null);
    }
  }, [showModal]);

  const handleRefresh = useCallback(() => {
    setRefreshFlag(refreshFlag + 1);
  }, [refreshFlag]);

  const columns = useMemo(
    () => [
      {
        id: "status",
        name: "",
        cell: (row) => (
          <div>
            <div
              className={row.active ? "active-container" : "inactive-container"}
            />
          </div>
        ),
        sortable: false,
        width: "60px",
      },

      {
        id: "photoImageRefId",
        name: "Image",
        selector: (row) => (
          <div className="table-img">
            <img
              src={getImageSrcViaRefId(row.photoImageRefId)}
              alt={row.gameTitle}
            />
          </div>
        ),
        sortable: false,
        center: true,
        maxWidth: "100px",
      },
      {
        id: "name",
        name: "Name",
        selector: (row) => `${row.firstName} ${row.lastName}`,
        sortable: true,
        reorder: true,
      },
      {
        id: "Gender",
        name: "Mobile Number",
        selector: (row) => row.gender,
        sortable: true,
        reorder: true,
      },
      {
        id: "phoneNo",
        name: "Mobile Number",
        selector: (row) => `${row.isdCode} ${row.mobile}`,
        sortable: true,
        reorder: true,
      },
      {
        id: "email",
        name: "Email",
        selector: (row) => row.email,
        sortable: true,
        reorder: true,
      },

      {
        id: "createdAtTimeStamp",
        name: "Created At",
        selector: (row) =>
          dateUtilities.formattedDate(
            row.createdAtTimeStamp,
            "dd-MM-yyyy hh:mm aa"
          ),
        sortable: true,
        reorder: true,
      },

      {
        id: "modifiedAtTimeStamp",
        name: "Modified At",
        selector: (row) =>
          dateUtilities.formattedDate(
            row.modifiedAtTimeStamp,
            "dd-MM-yyyy hh:mm aa"
          ),
        sortable: true,
        reorder: true,
      },
      {
        id: "action",
        name: "Action",
        style: {
          justifyContent: "flex-start",
        },
        cell: (row) => getActionEvents(row),
      },
    ],
    [handleRefresh, viewDeletedList]
  );
  const getActionEvents = (row) => {
    return (
      <div className="dropdown">
        <button
          className="btn btn-primary btn-sm dropdown-toggle"
          type="button"
          id="actionBtn"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          Action button
        </button>
        {viewDeletedList ? (
          <ul className="dropdown-menu" aria-labelledby="actionBtn">
            <li onClick={() => handleReviveEvent(row.uuid)}>Revive</li>
          </ul>
        ) : (
          <ul className="dropdown-menu" aria-labelledby="actionBtn">
            <li onClick={() => handleEdit(row.uuid)}>Edit</li>
            <li
              onClick={() => {
                row.active
                  ? handleInactiveEvent(row.uuid)
                  : handleActiveEvent(row.uuid);
              }}
            >
              {row.active ? "Inactive" : "Active"}
            </li>
            <li onClick={() => handleDeleteEvent(row.uuid)}>Delete</li>
          </ul>
        )}
      </div>
    );
  };

  const handleActiveEvent = (uuid) => {
    callPutApi(
      "loader",
      Activate_UserAdmin_List_Item_PUT.replace("{uuid}", uuid),
      record,
      {},
      (res) => {
        if (res.errorCode === API_SUCCESS) {
          toast.success("Activated Item Successfully");
          handleRefresh();
        }
      }
    );
  };
  const handleInactiveEvent = (uuid) => {
    callPutApi(
      "loader",
      Inactivate_UserAdmin_List_Item_PUT.replace("{uuid}", uuid),
      record,
      {},
      (res) => {
        if (res.errorCode === API_SUCCESS) {
          toast.success("Deactivated Item Successfully");
          handleRefresh();
        }
      }
    );
  };

  const handleDeleteEvent = (uuid) => {
    callDeleteApi(
      "loader",
      Delete_UserAdmin_Deleted_List_Item_DELETE.replace("{uuid}", uuid),
      {},
      (response) => {
        if (response.errorCode === API_SUCCESS) {
          //toast.success(response.message);
          toast.success("Delete Item Successfully");
          handleRefresh();
        }
      }
    );
  };

  const handleReviveEvent = (uuid) => {
    getRecordItems(uuid);
    callPutApi(
      "loader",
      Revive_UserAdmin_List_Item_PUT.replace("{uuid}", uuid),
      record,
      {},
      (res) => {
        if (res.errorCode === API_SUCCESS) {
          toast.success("Revive Item Successfully");
          handleRefresh();
        }
      }
    );
  };

  const getRecordItems = (uuid) => {
    callGetApi(
      "loader",
      Get_UserAdmin_List_Item_GET.replace("{uuid}", uuid),
      {},
      (res) => {
        setRecord(res.responsePacket);
      }
    );
  };

  const handleEdit = (uuid) => {
    setRecordID(uuid);
    setShowModal(true);
  };

  const handleAddEvent = () => {
    setShowModal(true);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="card shadow mt-3">
          <div className="text-end p-3 border-bottom d-flex align-content-center justify-content-between ">
            <div className="page-title-box ">
              <h4 className="mb-sm-0 font-size-18">User Admin</h4>
            </div>
            <div>
              {!viewDeletedList && (
                <button
                  className="btn btn-primary me-3"
                  onClick={() => handleAddEvent()}
                >
                  Add
                </button>
              )}

              <div className="btn form-check btn-primary ">
                <input
                  className="form-check-input ms-0"
                  type="checkbox"
                  onChange={() => setViewDeletedList(!viewDeletedList)}
                  id="flexCheckDefault"
                />
                <label
                  className="form-check-label text-light ps-2"
                  htmlFor="flexCheckDefault"
                >
                  Delete List
                </label>
              </div>
            </div>
          </div>
          <PaginationDataTable
            paginationUrl={
              viewDeletedList
                ? GET_UserAdmin_Deleted_List_POST
                : GET_UserAdmin_List_POST
            }
            serverSidePagination={true}
            search={false}
            pagination={false}
            columns={columns}
          />
        </div>
      </div>
      {showModal && (
        <UserAdminAddEdit
          show={showModal}
          hideModal={() => setShowModal(false)}
          recordID={recordID}
          handleRefresh={handleRefresh}
        />
      )}
    </>
  );
};

export default UserAdminMaster;
